/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipologiaComune } from './tipologia-comune';


export interface ComuneCompactDTO { 
    id?: string;
    nome?: string;
    slug?: string;
    prefisso_comune?: string;
    codice_fiscale?: string;
    email?: string;
    url_logo_comune?: string;
    url_comune?: string;
    tipologia?: TipologiaComune;
    enabled?: boolean;
    comune_nascosto?: boolean;
}



